import React from "react";
import { useCurrentFrame } from "remotion";

export interface VisualizerStyle {
  barWidth?: string;
  borderRadius?: string;
  border?: string;
  activeShadow?: string;
  inactiveShadow?: string;
  getBarBackground: (ratio: number) => string;
}

interface AudioVisualizerProps {
  active?: boolean;
  styleConfig?: VisualizerStyle;
}

const defaultVisualizerStyle: VisualizerStyle = {
  getBarBackground: (ratio: number) =>
    ratio < 0.5
      ? "linear-gradient(to top, rgba(157,78,221,0.45), #00f2fe)"
      : "linear-gradient(to top, #00f2fe, #ff007f)",
  activeShadow: "0 0 12px rgba(0, 242, 254, 0.45)",
};

export const AudioVisualizer: React.FC<AudioVisualizerProps> = ({
  active = true,
  styleConfig,
}) => {
  const frame = useCurrentFrame();
  const barCount = 36;
  const config = styleConfig ?? defaultVisualizerStyle;

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "6px",
        height: "100px",
        width: "100%",
        position: "relative",
        marginTop: "auto",
        marginBottom: "20px",
        zIndex: 5,
      }}
    >
      {Array.from({ length: barCount }).map((_, i) => {
        // Shifting wave shape: highly realistic audio frequency simulation
        const speed = 0.25;
        const indexOffset = i * 0.45;
        const wave =
          Math.sin(frame * speed + indexOffset) * 0.4 +
          Math.cos(frame * speed * 0.6 - indexOffset * 1.3) * 0.3 +
          Math.sin(frame * speed * 1.8 + indexOffset * 2.2) * 0.15;

        // Murmur vs. active bounce states perfectly synced with speech presence
        const activeMultiplier = active ? 1.0 : 0.06;
        const rawHeight = Math.abs(wave) * 90 * activeMultiplier + 8;
        const height = Math.min(Math.max(rawHeight, 6), 95);

        // Center weight (classic tall-spectrum shape)
        const distanceFromCenter = Math.abs(i - barCount / 2) / (barCount / 2);
        const centerFactor = 1.0 - distanceFromCenter * 0.5;
        const finalHeight = height * centerFactor;

        const ratio = i / barCount;
        const background = config.getBarBackground(ratio);
        const shadow = active
          ? (config.activeShadow ?? "none")
          : (config.inactiveShadow ?? "none");

        return (
          <div
            key={i}
            style={{
              width: config.barWidth ?? "8px",
              height: `${finalHeight}px`,
              borderRadius: config.borderRadius ?? "4px",
              background,
              border: config.border ?? "none",
              boxShadow: shadow,
              transition: "height 0.08s ease-out",
            }}
          />
        );
      })}
    </div>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
